import React from 'react';

const TermsOfUse = () => {
  const styles:any = {
    container: {
      maxWidth: '800px',
      margin: '0 auto',
      padding: '20px',
      backgroundColor: '#ffffff',
      color: '#000000',
      fontFamily: "'Arial', sans-serif",
      lineHeight: 1.6
    },
    header: {
      textAlign: 'center',
      marginBottom: '30px',
      borderBottom: '2px solid #000000',
      paddingBottom: '20px'
    },
    title: {
      fontSize: '2rem',
      fontWeight: 'bold',
      margin: 0,
      color: '#000000'
    },
    subtitle: {
      fontSize: '1.1rem',
      marginTop: '10px',
      color: '#333333',
      fontStyle: 'italic'
    },
    divider: {
      height: '1px',
      backgroundColor: '#000000',
      margin: '30px 0',
      width: '100%'
    },
    content: {
      marginBottom: '40px'
    },
    section: {
      marginBottom: '30px'
    },
    sectionTitle: {
      fontSize: '1.5rem',
      fontWeight: 'bold',
      marginBottom: '15px',
      color: '#000000',
      borderLeft: '4px solid #000000',
      paddingLeft: '10px'
    },
    text: {
      marginBottom: '15px',
      color: '#333333'
    },
    emphasizedText: {
      marginBottom: '15px',
      fontWeight: 'bold',
      color: '#000000'
    },
    listContainer: {
      listStyleType: 'none',
      paddingLeft: '20px',
      marginBottom: '20px'
    },
    listItem: {
      marginBottom: '8px',
      paddingLeft: '20px',
      position: 'relative',
      color: '#333333'
    },
    listBullet: {
      position: 'absolute',
      left: 0,
      color: '#000000',
      fontWeight: 'bold'
    },
    definitionList: {
      margin: '20px 0',
      padding: '15px',
      backgroundColor: '#f9f9f9',
      borderLeft: '3px solid #000000'
    },
    definitionItem: {
      marginBottom: '10px',
      display: 'flex'
    },
    definitionTerm: {
      fontWeight: 'bold',
      minWidth: '180px',
      color: '#000000'
    },
    definitionDescription: {
      flex: 1,
      color: '#333333'
    },
    prohibitedList: {
      listStyleType: 'none',
      paddingLeft: '0',
      marginBottom: '20px'
    },
    prohibitedItem: {
      marginBottom: '10px',
      paddingLeft: '25px',
      position: 'relative',
      color: '#333333'
    },
    prohibitedIcon: {
      position: 'absolute',
      left: 0,
      color: '#000000'
    },
    contactInfo: {
      listStyleType: 'none',
      paddingLeft: 0,
      marginTop: '20px'
    },
    contactItem: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '15px',
      padding: '10px',
      backgroundColor: '#f5f5f5',
      borderRadius: '4px'
    },
    contactIcon: {
      marginRight: '15px',
      fontSize: '1.2rem'
    },
    contactText: {
      color: '#000000',
      fontWeight: 500
    },
    footer: {
      textAlign: 'center',
      paddingTop: '20px',
      borderTop: '1px solid #000000',
      marginTop: '30px'
    },
    footerText: {
      color: '#666666',
      fontSize: '0.9rem'
    }
  };

  // Estilos responsivos
  if (window.innerWidth <= 768) {
    styles.title.fontSize = '1.7rem';
    styles.sectionTitle.fontSize = '1.3rem';
    styles.definitionItem.flexDirection = 'column';
    styles.definitionTerm.minWidth = '100%';
    styles.definitionTerm.marginBottom = '5px';
  }

  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <h1 style={styles.title}>Termos de Uso – ClikMob</h1>
        <p style={styles.subtitle}>
          Bem-vindo ao ClikMob, aplicativo de mobilidade urbana que conecta usuários a motoristas parceiros 
          para a realização de deslocamentos em Brasília e demais regiões onde o serviço estiver disponível.
        </p>
        <p style={styles.emphasizedText}>
          Ao acessar ou utilizar o aplicativo ClikMob, você declara que leu, entendeu e concorda com estes Termos de Uso.
        </p>
        <div style={styles.divider}></div>
      </header>
      
      <main style={styles.content}>
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>1. Definições</h2>
          <div style={styles.definitionList}>
            <div style={styles.definitionItem}>
              <span style={styles.definitionTerm}>• ClikMob:</span>
              <span style={styles.definitionDescription}>Aplicativo de mobilidade urbana.</span>
            </div>
            <div style={styles.definitionItem}>
              <span style={styles.definitionTerm}>• Usuário:</span>
              <span style={styles.definitionDescription}>Pessoa física que utiliza o aplicativo para solicitar viagens.</span>
            </div>
            <div style={styles.definitionItem}>
              <span style={styles.definitionTerm}>• Motorista Parceiro:</span>
              <span style={styles.definitionDescription}>Prestador de serviço independente cadastrado na plataforma.</span>
            </div>
            <div style={styles.definitionItem}>
              <span style={styles.definitionTerm}>• Aplicativo:</span>
              <span style={styles.definitionDescription}>Software disponibilizado para dispositivos móveis.</span>
            </div>
          </div>
          <div style={styles.divider}></div>
        </section>
        
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>2. Aceitação dos Termos</h2>
          <p style={styles.text}>
            O uso do ClikMob implica na aceitação integral destes Termos e da Política de Privacidade.
          </p>
          <p style={styles.emphasizedText}>
            Caso o usuário não concorde, não deverá utilizar o aplicativo.
          </p>
          <div style={styles.divider}></div>
        </section>
        
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>3. Elegibilidade</h2>
          <p style={styles.text}>
            Para utilizar o ClikMob, o usuário deve:
          </p>
          <ul style={styles.listContainer}>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> Ter no mínimo 18 anos</li>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> Possuir capacidade civil plena</li>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> Fornecer informações verdadeiras no cadastro</li>
          </ul>
          <div style={styles.divider}></div>
        </section>
        
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>4. Cadastro do Usuário</h2>
          <p style={styles.text}>
            O usuário se compromete a:
          </p>
          <ul style={styles.listContainer}>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> Informar dados corretos e atualizados</li>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> Manter a confidencialidade de sua conta</li>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> Ser responsável por todas as atividades realizadas em seu acesso</li>
          </ul>
          <p style={styles.text}>
            A ClikMob pode suspender ou cancelar contas com informações falsas ou uso indevido.
          </p>
          <div style={styles.divider}></div>
        </section>
        
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>5. Funcionamento do Serviço</h2>
          <p style={styles.text}>
            O ClikMob atua como plataforma intermediadora, não sendo:
          </p>
          <ul style={styles.listContainer}>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> Proprietária dos veículos</li>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> Empregadora dos motoristas parceiros</li>
          </ul>
          <p style={styles.text}>
            A responsabilidade pela execução da viagem é do motorista parceiro.
          </p>
          <div style={styles.divider}></div>
        </section>
        
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>6. Solicitação e Cancelamento de Viagens</h2>
          <ul style={styles.listContainer}>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> As viagens são solicitadas pelo aplicativo</li>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> O valor estimado será informado antes da confirmação</li>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> Cancelamentos podem gerar cobranças, conforme regras exibidas no app</li>
          </ul>
          <div style={styles.divider}></div>
        </section>
        
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>7. Pagamentos</h2>
          <p style={styles.text}>
            O ClikMob pode disponibilizar formas de pagamento como:
          </p>
          <ul style={styles.listContainer}>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> Dinheiro</li>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> Cartão</li>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> PIX</li>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> Outros meios digitais</li>
          </ul>
          <p style={styles.text}>
            A ClikMob não se responsabiliza por falhas de instituições financeiras.
          </p>
          <div style={styles.divider}></div>
        </section>
        
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>8. Conduta do Usuário</h2>
          <p style={styles.text}>
            É proibido ao usuário:
          </p>
          <ul style={styles.prohibitedList}>
            <li style={styles.prohibitedItem}>
              <span style={styles.prohibitedIcon}>✗</span>
              Utilizar o aplicativo para fins ilícitos
            </li>
            <li style={styles.prohibitedItem}>
              <span style={styles.prohibitedIcon}>✗</span>
              Praticar assédio, discriminação ou violência
            </li>
            <li style={styles.prohibitedItem}>
              <span style={styles.prohibitedIcon}>✗</span>
              Danificar veículos ou equipamentos
            </li>
            <li style={styles.prohibitedItem}>
              <span style={styles.prohibitedIcon}>✗</span>
              Fornecer informações falsas
            </li>
          </ul>
          <p style={styles.text}>
            O descumprimento pode resultar em bloqueio ou exclusão da conta.
          </p>
          <div style={styles.divider}></div>
        </section>
        
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>9. Avaliações</h2>
          <p style={styles.text}>
            Usuários e motoristas podem se avaliar mutuamente.
          </p>
          <p style={styles.text}>
            Avaliações abusivas ou fraudulentas podem ser removidas.
          </p>
          <div style={styles.divider}></div>
        </section>
        
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>10. Suspensão e Encerramento da Conta</h2>
          <p style={styles.text}>
            A ClikMob poderá suspender ou encerrar a conta do usuário:
          </p>
          <ul style={styles.listContainer}>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> Em caso de violação destes Termos</li>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> Por exigência legal ou judicial</li>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> Para garantir a segurança da plataforma</li>
          </ul>
          <div style={styles.divider}></div>
        </section>
        
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>11. Limitação de Responsabilidade</h2>
          <p style={styles.text}>
            A ClikMob não se responsabiliza por:
          </p>
          <ul style={styles.listContainer}>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> Atos praticados por motoristas ou usuários</li>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> Perdas decorrentes de falhas técnicas</li>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> Objetos esquecidos durante a viagem</li>
          </ul>
          <div style={styles.divider}></div>
        </section>
        
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>12. Propriedade Intelectual</h2>
          <p style={styles.text}>
            Todo o conteúdo do aplicativo (marca, logotipo, layout, textos) pertence à ClikMob e não pode ser utilizado sem autorização.
          </p>
          <div style={styles.divider}></div>
        </section>
        
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>13. Alterações nos Termos</h2>
          <p style={styles.text}>
            Estes Termos podem ser alterados a qualquer momento.
          </p>
          <p style={styles.emphasizedText}>
            O uso contínuo do aplicativo após as alterações representa aceitação automática.
          </p>
          <div style={styles.divider}></div>
        </section>
        
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>14. Legislação Aplicável e Foro</h2>
          <p style={styles.text}>
            Estes Termos são regidos pelas leis da República Federativa do Brasil.
          </p>
          <p style={styles.text}>
            Fica eleito o Foro da Comarca de Brasília – Distrito Federal para dirimir quaisquer controvérsias.
          </p>
          <div style={styles.divider}></div>
        </section>
        
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>15. Contato</h2>
          <p style={styles.text}>
            Para dúvidas, reclamações ou solicitações:
          </p>
          <ul style={styles.contactInfo}>
            <li style={styles.contactItem}>
              <span style={styles.contactIcon}>📧</span> 
              <span style={styles.contactText}>E-mail: contato@clikmob.com</span>
            </li>
            <li style={styles.contactItem}>
              <span style={styles.contactIcon}>🏢</span> 
              <span style={styles.contactText}>ClikMob – Aplicativo de Mobilidade</span>
            </li>
          </ul>
        </section>
      </main>
      
      <footer style={styles.footer}>
        <p style={styles.footerText}>ClikMob © {new Date().getFullYear()} - Termos de Uso</p>
      </footer>
    </div>
  );
};

export default TermsOfUse;